import React from 'react';

const RequestActions = (props) => {
    const {actions} = props;

    return (
        <dl className="action-list" data-testid="action-dl">
            {actions.map((action, i) => (
                <div key={i} className="action-item">
                    <dt
                        className="action-item__type text-400"
                        data-testid="action-label"
                    >
                        {action.label}
                    </dt>
                    <dd
                        className="action-item__timestamp"
                        data-testid="action-time"
                    >
                        <strong>{action.time}</strong>
                    </dd>
                </div>
            ))}
        </dl>
    );
};

export default RequestActions;
